import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { gl } from '@antv/l7-core';
import { rgb2arr } from '@antv/l7-utils';
import { isNumber } from 'lodash';
import BaseModel from "../../core/BaseModel";
import { polygonTriangulation } from "../../core/triangulation";

/* babel-plugin-inline-import '../../shader/minify_frag.glsl' */
var mask_frag = "uniform float u_opacity : 1.0;\nuniform vec4 u_color;\n\nvoid main() {\n  gl_FragColor = u_color;\n  gl_FragColor.a *= u_opacity;\n}\n";

/* babel-plugin-inline-import '../shaders/mask_vert.glsl' */
var mask_vert = "attribute vec3 a_Position;\nuniform mat4 u_ModelMatrix;\nuniform mat4 u_Mvp;\n\n#pragma include \"projection\"\n\nvoid main() {\n  vec4 project_pos = project_position(vec4(a_Position, 1.0));\n\n  if(u_CoordinateSystem == COORDINATE_SYSTEM_P20_2) { // gaode2.x\n    gl_Position = u_Mvp * (vec4(project_pos.xyz, 1.0));\n  } else {\n    gl_Position = project_common_position_to_clipspace(vec4(project_pos.xyz, 1.0));\n  }\n}\n\n";

var MaskModel = /*#__PURE__*/function (_BaseModel) {
  _inherits(MaskModel, _BaseModel);

  var _super = _createSuper(MaskModel);

  function MaskModel() {
    _classCallCheck(this, MaskModel);

    return _super.apply(this, arguments);
  }

  _createClass(MaskModel, [{
    key: "getUninforms",
    value: function getUninforms() {
      var _ref = this.layer.getLayerConfig(),
          _ref$opacity = _ref.opacity,
          opacity = _ref$opacity === void 0 ? 0 : _ref$opacity,
          _ref$color = _ref.color,
          color = _ref$color === void 0 ? '#000' : _ref$color;

      return {
        u_opacity: isNumber(opacity) ? opacity : 0.0,
        u_color: rgb2arr(color)
      };
    }
  }, {
    key: "initModels",
    value: function initModels(callbackModel) {
      this.buildModels(callbackModel);
    }
  }, {
    key: "buildModels",
    value: function () {
      var _buildModels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(callbackModel) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.layer.buildLayerModel({
                  moduleName: 'mask',
                  vertexShader: mask_vert,
                  fragmentShader: mask_frag,
                  triangulation: polygonTriangulation,
                  depth: {
                    enable: false
                  },
                  blend: this.getBlend(),
                  stencil: {
                    enable: true,
                    mask: 0xff,
                    func: {
                      cmp: gl.ALWAYS,
                      ref: 1,
                      mask: 0xff
                    },
                    opFront: {
                      fail: gl.REPLACE,
                      zfail: gl.REPLACE,
                      zpass: gl.REPLACE
                    }
                  },
                  pick: false
                }).then(function (model) {
                  callbackModel([model]);
                }).catch(function (err) {
                  console.warn(err);
                  callbackModel([]);
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildModels(_x) {
        return _buildModels.apply(this, arguments);
      }

      return buildModels;
    }()
  }, {
    key: "clearModels",
    value: function clearModels() {
      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      refresh && this.layerService.clear();
    }
  }, {
    key: "registerBuiltinAttributes",
    value: function registerBuiltinAttributes() {
      return '';
    }
  }]);

  return MaskModel;
}(BaseModel);

export { MaskModel as default };